export default {"src":"/_next/static/media/serviceLead.4ad44c99.svg","height":144,"width":412};